import { useEffect } from 'react';

/**
 * PerformanceOptimizer - Hook za optimizaciju performansi
 * Implementira različite performance optimizacije
 */
const usePerformanceOptimizer = () => {
  
  useEffect(() => {
    // 1. Detect prefers-reduced-motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    if (prefersReducedMotion.matches) {
      document.body.classList.add('reduce-motion');
    }

    // 2. Passive event listeners za scroll - štedi CPU
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Scroll logika ovde
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    // 3. Connection-aware loading
    if ('connection' in navigator) {
      const connection = navigator.connection;
      if (connection.effectiveType === '2g' || connection.saveData) {
        document.body.classList.add('slow-connection');
      }
    }

    // 4. Prefetch kritičnih resursa
    const prefetchLinks = [
      '/haus niggemman_1.png',
    ];

    prefetchLinks.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    });

    // 5. Resource hints
    const preconnectDomains = [
      'https://fonts.googleapis.com',
      'https://widgets.sociablekit.com',
    ];

    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Battery Status API - smanjiti animacije ako je baterija slaba
  useEffect(() => {
    if ('getBattery' in navigator) {
      navigator.getBattery().then(battery => {
        const updateBatteryStatus = () => {
          if (battery.level < 0.2 && !battery.charging) {
            document.body.classList.add('low-battery');
            console.log('⚡ Low battery mode activated - animations reduced');
          } else {
            document.body.classList.remove('low-battery');
          }
        };

        battery.addEventListener('levelchange', updateBatteryStatus);
        battery.addEventListener('chargingchange', updateBatteryStatus);
        updateBatteryStatus();

        return () => {
          battery.removeEventListener('levelchange', updateBatteryStatus);
          battery.removeEventListener('chargingchange', updateBatteryStatus);
        };
      });
    }
  }, []);

  // Visibility API - pauzirati animacije kada tab nije aktivan
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        document.body.classList.add('page-hidden');
      } else {
        document.body.classList.remove('page-hidden');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
};

export default usePerformanceOptimizer;
